import { useMemo } from 'react';

const useTableDataHelper = (loading, data) => {
    const tableData = useMemo(() => loading
        ? Array.from({ length: 100 }, (_, index) => index).map(index => {
            return { id: index, hidden: true };
        })
        : data, [loading, data]);
    return {
        tableData,
    };
};

export { useTableDataHelper };
//# sourceMappingURL=useTableDataHelper.js.map
